import store from "../store";
import axios from "axios";

class Users {
	getSelf(client = false) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			if (!store.state.jwt) return null;
			var url = `${process.env.VUE_APP_SAAS_BACK}` + "/users/self";
			if (client) url += "?client=true";
			axios
				.get(url, {
					headers: {
						Authorization: "bearer " + jwt,
					},
				})
				.then(function (response) {
					if (client) resolve(response.data);
					else resolve(response.data.user);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}
	reniew() {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			if (!store.state.jwt) 
				return null;
			var url = `${process.env.VUE_APP_SAAS_BACK}` + "/users/reniew";
			axios
				.get(url, {
					headers: {
						Authorization: "bearer " + jwt,
					},
				})
				.then(function (response) {

					console.log(response.data.jwt);

					let jwt = response.data.jwt;
					store.commit("setJwt", jwt);

					resolve()
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	getUser(id) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			var url = `${process.env.VUE_APP_SAAS_BACK}` + "/users/" + id;
			axios
				.get(url, {
					headers: {
						Authorization: "bearer " + jwt,
					},
				})
				.then(function (response) {
					resolve(response.data.user);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}

	updateUser(user, actual_group) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			var url = `${process.env.VUE_APP_SAAS_BACK}` + "/users/update";
			axios
				.post(
					url,
					{ 
						user,
						group: actual_group || null
				    },
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data.user);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}

	updateUserSelf(user, group) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			var url = `${process.env.VUE_APP_SAAS_BACK}` + "/users/update_self";
			axios
				.post(
					url,
					{ 
						user,
						group: group || null
				 	},
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data.user);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}

	generateJwt(uid) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			var url = `${process.env.VUE_APP_SAAS_BACK}` + "/users/generate_jwt/" + uid;
			axios
				.post(
					url,
					{ },
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data.jwt);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}

	generateJwtSelf() {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			var url = `${process.env.VUE_APP_SAAS_BACK}` + "/users/generate_jwt_self";
			axios
				.post(
					url,
					{ },
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data.jwt);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}

	async sendFileFtp(data) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/users/upload_ftp",
					data,
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					console.log(error);
					console.log("error : " + error);
					//reject(error)
				});
		});
	}
}

export default new Users();
